import React from 'react'
import { useTranslation } from 'react-i18next'
import { Emblem, Paragraph } from '../../../components/common'
import './Discover.css'

// import Navigator component from src/navigation
import Navigator from '../../../navigation/Navigator/Navigator'

const Discover = () => {
    const { t } = useTranslation();
    return (
        <div className="container">
            <div className="col grid-line">
                <div className="">
                    <Navigator />
                </div>
                <div className="blank">
                    {/* blank component */}
                </div>
            </div>
            <div className="col p-1d6-em">
                <div className="col">
                    <Paragraph>
                        {t('discover_text')}
                    </Paragraph>     
                    <Emblem />
                </div>
                <div className="col scroll">
                    <p>{t('discover_scroll')}..</p>
                </div>
            </div>
        </div>
    )
}

export default Discover
